import React, { CSSProperties } from 'react';
import styles from './BrazeBannerPlaceholder.module.scss';

interface IBrazeBannerPlaceholderProps {
  elementId: string;
  css?: CSSProperties;
}
export const BrazeBannerPlaceholder: React.FC<IBrazeBannerPlaceholderProps> = (
  props: IBrazeBannerPlaceholderProps
) => {
  return (
    <div
      className={styles.brazePlaceholder}
      id={props.elementId}
      style={props.css ?? {}}
    />
  );
};
